var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageShell',{staticClass:"page-shell-wrapper--blog-post",attrs:{"locale":"id","hide-title":""}},[(_vm.slug)?_c('BlogPostContent',{attrs:{"slug":_vm.slug}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }